<template>
    <div class="templete_box">
        <navTab :navlist="navlist" :nav-index="tab"  :templateName="'bankingPayableRedeemList'" @reback="res=>{this.tab = res;}"></navTab>
        <sales @child-num='emitNum' v-if="Number(tab) === 0"></sales>
        <bring @child-num='emitNum' v-if="Number(tab) === 1"></bring>
    </div>
</template>
<script>
    import sales from './components/sales';
    import bring from './components/bring';
    export default {
        data(){
            return{
                navlist:['销售赎货'+'('+')','提前赎货'],
                tab:1,
                saleNum:''
            }
        },
        created(){
            if(sessionStorage.TOADVANCE){
                this.tab=Number(sessionStorage.TOADVANCE);
                sessionStorage.removeItem("TOADVANCE")
            }else{
                this.tab=0;
            }
            // this.emitNum()
        },
        methods:{
            emitNum(data){
                this.saleNum = data;
                this.navlist = ['销售赎货'+'('+ data.sales_count+')','提前赎货'+'('+ data.advance_count+')']
            }
        },
        components:{
            sales,
            bring
        }
    }
</script>
<style scoped>

</style>